import { ProductType } from "booking_app/types";
import { TravelType } from "booking_app/types/travel-type";

export class MastheadDescriptionController {
  static $inject = [
    "$rootScope",
  ];

  // Bindings
  travelType: string;
  whitelabel: string;
  productType: string;
  hasCustomHeaderText: boolean = false;
  customHeaderKey: string;
  customDescriptionKey: string;

  constructor(
    private $rootScope: any,
  ) {}

  header(): string {
    if (this.customHeaderKey) {
      return this.customHeaderKey;
    }

    if (this.hasCustomHeaderText && this.productType === ProductType.REDEEM && this.travelType === TravelType.HOTELS) {
      return `wl.${this.whitelabel}.${this.travelType}_header_redeem`;
    }

    if (this.whitelabel === "fab" && this.hasCustomHeaderText) {
      return `wl.${this.whitelabel}.${this.travelType}_custom_header`;
    }

    // wl.whitelabelName.hotels_header
    return `wl.${this.whitelabel}.${this.travelType}_header`;
  }

  description(): string {
    if (this.customDescriptionKey) {
      return this.customDescriptionKey;
    }

    if (this.whitelabel === "fab" && this.hasCustomHeaderText) {
      return `wl.${this.whitelabel}.${this.travelType}_custom_description`;
    }

    // wl.whitelabelName.hotels_description
    return `wl.${this.whitelabel}.${this.travelType}_description`;
  }
}
